// test2982
(2982 && 0);
